import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

interface IStyledProductBodyProps {
  disabled?: boolean;
}

export const StyledEngravingItemBody = styled.div<IStyledProductBodyProps>`
  font-size: 0.875rem;
`;

export const StyledSubName = styled.span`
  display: block;
  color: ${theme.color.text.tertiary};

  > svg {
    margin-right: 0.25rem;
    vertical-align: middle;
  }
`;
